export default __webpack_public_path__ + "static/media/hht2_ep18_timeline_q01_b.68e78fe8.png";